<template>
  <div id="app" class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
  @import "sass/main.scss";
  @import "sass/custom/main.scss";
</style>



// WEBPACK FOOTER //
// App.vue?40d05566